import { Component, Input, OnChanges, output } from '@angular/core';
import { Status } from '../status/status.component';
import {
  CheckItemV2,
  CheckboxStatus,
  GridTemplateFilterFilterValueV2,
  CheckboxV2Module,
  InputV2Module,
} from '@schenck/rotec-components';

@Component({
  selector: 'ma-status-filter',
  templateUrl: './status-filter.component.html',
  styleUrls: ['./status-filter.component.less'],
  imports: [CheckboxV2Module, InputV2Module],
})
export class StatusFilterComponent implements OnChanges {
  @Input()
  value: Status[];

  readonly valueChange = output<Status[]>();

  public get redCheckbox(): CheckItemV2<any> {
    return {
      name: 'Red',
      value: { name: 'Red', value: 100 },
      status: this.checked('Red'),
    };
  }

  public get orangeCheckbox(): CheckItemV2<any> {
    return {
      name: 'Orange',
      value: { name: 'Orange', value: 80 },
      status: this.checked('Orange'),
    };
  }

  public get greenCheckbox(): CheckItemV2<any> {
    return {
      name: 'Green',
      value: { name: 'Green', value: 0 },
      status: this.checked('Green'),
    };
  }

  public get percentageCheckbox(): CheckItemV2<any> {
    return {
      name: 'Percentage',
      value: { name: 'Percentage' },
      status: this.checked('Percentage'),
    };
  }

  public static filterforStatus(status: Status[]): GridTemplateFilterFilterValueV2[] {
    const displayValues = status.map((state) =>
      state.name !== 'Percentage'
        ? <GridTemplateFilterFilterValueV2>{ value: state.name, displayValue: state.name }
        : <GridTemplateFilterFilterValueV2>{
            value: state.name,
            displayValue: 'Less than VALUE',
            displayValueTranslateParams: { value: state.value + '%' },
          }
    );
    return displayValues;
  }

  public static deleteStatusFilter(
    filterValue: Status[],
    toDelete: GridTemplateFilterFilterValueV2
  ) {
    return filterValue.filter((val) => val.name !== toDelete.value);
  }

  percentageValue: number;

  ngOnChanges() {
    if (!this.value) {
      this.value = [];
    }

    const currentStatus = this.value.find(this.isPercentage);
    if (currentStatus) {
      this.percentageValue = currentStatus.value;
    } else {
      this.percentageValue = 0;
    }

    if (!this.value || this.value.length === 0) {
      this.value = [
        { name: 'Red', value: 10 },
        { name: 'Orange', value: 30 },
        { name: 'Green', value: 100 },
      ];
    }
  }

  toggleValue(status: Status, checked: CheckboxStatus) {
    let value = [];
    if (this.isPercentage(status)) {
      if (checked) {
        this.value = [];
        value.push(status);
      }
    } else {
      const currentValues = this.value.filter(
        (val) => !this.isPercentage(val) && val.name !== status.name
      );
      value = [...currentValues];
      if (checked === 'checked') {
        value.push(status);
      }
    }

    this.valueChange.emit(value);
  }

  checked(statusName: string): CheckboxStatus {
    return this.value.find((status) => status.name === statusName) ? 'checked' : 'unchecked';
  }

  changeInputValue(event: string) {
    this.percentageValue = parseInt(event, 10);

    if (this.value.filter((status) => !this.isPercentage(status)).length === 0) {
      const value = [];
      value.push({ name: 'Percentage', value: this.percentageValue });
      this.valueChange.emit(value);
    }
  }

  private isPercentage(status: Status) {
    return status.name === 'Percentage';
  }
}
